<template>
  <div>
    <Head title="Mitarbeiter/In erstellen" />

    <h1 class="mb-8 text-3xl font-bold flex">
      <loading-button text="Zurück" inverted icon-name="arrow-left" func="link" :href="'/departments/' + department.id + '/edit'" class="mb-4 sm:mb-0 sm:mr-4"/>

      <HeroIcon name="people" class="mr-2 h-10 w-10 fill-orfBlue-100" />
      <Link class="text-orfBlue-400 hover:text-orfBlue-600 mt-1" :href="'/departments/' + department.id + '/edit'">
        {{ department.name }}</Link>
      <span class="text-orfBlue-400 font-medium mx-2 mt-1">/</span>
      <Link class="text-orfBlue-400 hover:text-orfBlue-600 mt-1" href="/users">MitarbeiterIn</Link>
      <span class="text-orfBlue-400 font-medium mx-2 mt-1">/</span>
      <div class="mt-1">Erstellen</div>
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Vorname" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nachname" />
<!--          <text-input v-model="form.username" :error="form.errors.username" class="pb-8 pr-6 w-full lg:w-1/2" label="Username" />-->
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
<!--          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />-->

          <select-input v-model="form.team_id" :pre="user && user.team ? user.team.id : (team ? team.id : null)" :error="form.errors.team_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Team">
            <option :value="null">Kein Team</option>
            <option v-for="team in teams" :key="team.id" :value="team.id">{{team.name}}</option>
          </select-input>
          <select-input v-if="is_dev" v-model="form.admin" :pre="false" :error="form.errors.admin" class="pb-8 pr-6 w-full lg:w-1/2" label="Admin">
            <option :value="true">Ja</option>
            <option :value="false">Nein</option>
          </select-input>
          <!--<file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
        -->
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" text="Mitarbeiter erstellen" class="ml-auto" icon-name="save" icon-custom-icon/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import HeroIcon from '@/Shared/HeroIcon.vue'

export default {
  components: {
    HeroIcon,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    teams: Array,
    team: Object,
    department: Object,
    is_dev: Boolean,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
        admin: false,
        photo: null,
        team_id: this.team ? this.team.id : null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/departments/' + this.department.id + '/users')
    },
  },
}
</script>
